import { useQuery } from '@tanstack/react-query'
import { getProcessWarehouses } from '@/api/processes-api'
import { toProcessEcommerceScope } from './process-ecommerce-scope'

// A filter dropdown wants onlyReferenced; a picker that assigns a warehouse needs the full list.
export const useProcessWarehouses = (
  ecommerceIds?: string[],
  onlyReferenced = false
) => {
  return useQuery({
    queryKey: onlyReferenced
      ? ['process-warehouses', ecommerceIds, 'referenced']
      : ['process-warehouses', ecommerceIds],
    queryFn: async ({ signal }) => {
      const response = await getProcessWarehouses(
        {
          pbFindProcessWarehousesRequest: {
            ...toProcessEcommerceScope(ecommerceIds),
            only_referenced_by_processes: onlyReferenced
          }
        },
        signal
      )
      return response.warehouses ?? []
    },
    staleTime: Infinity
  })
}
